import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var chooseImage = normalize.chooseImage(function (args) {
  return ks.chooseImage(args);
}, CONTAINER_NAME.KWAI);
export default chooseImage;